/* Ambiance Éclat — mention « paiement en plusieurs fois sans frais » sous le prix produit.
   Le montant suit la variante sélectionnée. Le thème ne rafraîchit que le TEXTE du prix
   (l'attribut data-value reste figé), on lit donc le texte affiché. */
(function () {
  'use strict';

  // ── Réglages ───────────────────────────────────────────────────────────────
  // Un organisme désactivé (actif: false) disparaît de la ligne et de l'infobulle.
  // Les bornes sont celles annoncées en France, en centimes.
  var ORGANISMES = [
    { nom: 'Klarna', fois: 3, actif: true, mini: 3500, maxi: 150000 },
    { nom: 'PayPal', fois: 4, actif: true, mini: 3000, maxi: 200000 }
  ];
  // ───────────────────────────────────────────────────────────────────────────

  var HORS_CONTEXTE = 'sticky-add-to-cart, product-card, cart-drawer, quick-add-dialog, .quick-add, .product-card';

  // Les URL des logos sont passées par le tag <script> dans layout/theme.liquid,
  // le JS n'ayant pas accès au filtre asset_url de Liquid.
  var balise = document.querySelector('script[data-logo-paypal]');
  var LOGOS = {
    PayPal: balise ? balise.getAttribute('data-logo-paypal') : '',
    Klarna: balise ? balise.getAttribute('data-logo-klarna') : ''
  };

  function centimesDepuisTexte(txt) {
    if (!txt) return NaN;
    // \s couvre déjà l'espace insécable et l'espace fine, mais on les nomme
    // pour que l'intention reste lisible : les prix français en sont truffés.
    var t = String(txt).replace(/[\s  ]/g, '').replace(/[^0-9.,]/g, '');
    if (!t) return NaN;
    if (t.indexOf(',') > -1) {
      t = t.replace(/\./g, '').replace(',', '.');
    } else if (!/\.\d{1,2}$/.test(t)) {
      t = t.replace(/\./g, '');
    }
    var v = parseFloat(t);
    return isNaN(v) ? NaN : Math.round(v * 100);
  }

  function euros(centimes) {
    return (centimes / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // Répartition : versements égaux, le premier absorbe le reste (usage PayPal / Klarna).
  function echeances(total, n) {
    var base = Math.floor(total / n);
    var premier = base + (total - base * n);
    return { premier: premier, autres: base, egal: premier === base };
  }

  function elementPrix() {
    var candidats = document.querySelectorAll('product-price [data-ref="price"]');
    for (var i = 0; i < candidats.length; i++) {
      if (!candidats[i].closest(HORS_CONTEXTE)) return candidats[i];
    }
    return null;
  }

  function montantCourant() {
    var el = elementPrix();
    if (!el) return NaN;
    var c = centimesDepuisTexte(el.textContent);
    if (!isNaN(c) && c > 0) return c;
    var dv = parseInt(el.getAttribute('data-value'), 10);
    return isNaN(dv) ? NaN : dv;
  }

  function conteneur() {
    var el = elementPrix();
    if (!el) return null;
    return el.closest('product-price') || el.parentElement;
  }

  function creerBloc() {
    var wrap = document.createElement('div');
    wrap.className = 'ae-fractionne';
    wrap.innerHTML =
      '<span class="ae-fractionne__texte"></span>' +
      '<span class="ae-fractionne__fin">' +
        '<span class="ae-fractionne__logos"></span>' +
        '<button type="button" class="ae-fractionne__aide" aria-label="Détail du paiement en plusieurs fois">?' +
          '<span class="ae-fractionne__bulle" role="tooltip"></span>' +
        '</button>' +
      '</span>';
    return wrap;
  }

  function maj() {
    var total = montantCourant();
    var cible = conteneur();
    if (!cible) return;

    var plans = isNaN(total) ? [] : ORGANISMES.filter(function (o) {
      return o.actif && total >= o.mini && total <= o.maxi;
    });

    var bloc = document.querySelector('.ae-fractionne');
    if (!plans.length) {
      if (bloc) bloc.remove();
      return;
    }

    if (!bloc) {
      bloc = creerBloc();
      cible.insertAdjacentElement('afterend', bloc);
    } else if (bloc.previousElementSibling !== cible) {
      cible.insertAdjacentElement('afterend', bloc);
    }

    // Ligne visible : on met en avant le versement le plus faible.
    var plusPetit = plans.reduce(function (a, b) { return b.fois > a.fois ? b : a; });
    var e = echeances(total, plusPetit.fois);

    // Une seule mensualité annoncée, pour tenir sur une ligne courte sous le
    // prix. Le détail organisme par organisme reste dans l'infobulle.
    bloc.querySelector('.ae-fractionne__texte').textContent =
      'Ou ' + plusPetit.fois + 'x ' + euros(e.autres) + ' sans frais avec';

    // Ordre d'affichage des logos, indépendant de l'ordre des échéanciers.
    var RANG = { PayPal: 1, Klarna: 2 };
    bloc.querySelector('.ae-fractionne__logos').innerHTML = plans
      .filter(function (p) { return LOGOS[p.nom]; })
      .slice()
      .sort(function (a, b) { return (RANG[a.nom] || 9) - (RANG[b.nom] || 9); })
      .map(function (p) {
        return '<img class="ae-fractionne__logo ae-fractionne__logo--' + p.nom.toLowerCase() +
               '" src="' + LOGOS[p.nom] + '" alt="' + p.nom + '" loading="lazy" decoding="async">';
      })
      .join('<span class="ae-fractionne__et">et</span>');

    var lignes = plans.map(function (p) {
      var d = echeances(total, p.fois);
      var detail = d.egal
        ? p.fois + ' × ' + euros(d.autres)
        : euros(d.premier) + ' aujourd’hui, puis ' + (p.fois - 1) + ' × ' + euros(d.autres);
      return '<span class="ae-fractionne__ligne"><b>En ' + p.fois + ' fois</b> — ' + detail +
             ' <em>' + p.nom + '</em></span>';
    }).join('');

    bloc.querySelector('.ae-fractionne__bulle').innerHTML =
      lignes + '<span class="ae-fractionne__note">Sans frais, sous réserve d’acceptation. ' +
      'Le choix se fait au moment du paiement.</span>';
  }

  function majDifferee() {
    setTimeout(maj, 80);
    setTimeout(maj, 350);
    setTimeout(maj, 900);
  }

  function init() {
    maj();
    ['variant:updated', 'variant:selected', 'form:updated', 'cart:updated'].forEach(function (ev) {
      document.addEventListener(ev, majDifferee);
    });
    var cible = conteneur();
    if (cible && window.MutationObserver) {
      new MutationObserver(majDifferee).observe(cible, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
